import {addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, where} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addPods,
    updateSinglePod,
    deleteSinglePod,
    getSinglePod,
    getDefaultPod,
    searchPods,
    preparePodsList
}

const collectionName = 'pods';
const collectionReference = collection(fireStoreDB, collectionName);

const addPods = (pods) => {
    return Promise.map(pods, async pod => {
        await addSinglePod(pod);
    });
}

const addSinglePod = (pod) => {
    return addDoc(collectionReference, pod);
}

const updateSinglePod = (pod) => {
    const documentReference = doc(fireStoreDB, collectionName, pod.id);
    return setDoc(documentReference, pod);
}

const deleteSinglePod = (pod) => {
    const documentReference = doc(fireStoreDB, collectionName, pod.id);
    return deleteDoc(documentReference);
}

const getSinglePod = (podId) => {
    const documentReference = doc(fireStoreDB, collectionName, podId);
    return getDoc(documentReference);
}

const getDefaultPod = async () => {
    let searchQuery = query(collectionReference);
    searchQuery = query(collectionReference, where("isDefault", "==", true));
    const podResult = await getDocs(searchQuery);
    return preparePodsList(podResult);
}

const searchPods = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    const podResult = await getDocs(searchQuery);
    return preparePodsList(podResult);
}

const preparePodsList = (podResult) => {
    const podsList = [];

    _.forEach(podResult.docs, podDoc => {
        podsList.push(prepareSinglePod(podDoc));
    });

    return podsList;
}

const prepareSinglePod = (podResult) => {
    const pod = podResult.data();
    pod.id = podResult.id;

    return pod;
}
